module.exports = __webpack_public_path__ + "static/media/reference-slider-12.7be7f7af.jpg";